<template>
  <div
    v-if="artwork.currentUserPresent"
    class="col-lg-4 ml-lg-auto"
    :class="{'col-xl-3' : canNotOrderForHammer || canNotOrderForLive}">
    <div v-if="canNotOrderForLive">
      {{ I18n.t("artworks.artwork_auction_finished_or_in_progress") }}
    </div>
    <div v-else-if="canNotOrderForHammer">
      {{ I18n.t("auctions_catalogs.auction_started_cannot_add_order") }}
    </div>
    <div v-else-if="orderPresent">
      <button
        @click="openModal(index)"
        class="GTM__modal btn btn__default mt-2 mt-md-3 mt-lg-0 col-sm-5 col-lg-12"
      >
        {{ I18n.t("orders.edit") }}
      </button>
    </div>
    <div v-else>
      <button
        @click="openModal(index)"
        class="GTM__modal btn btn__default mt-2 mt-md-3 mt-lg-0 col-sm-5 col-lg-12"
      >
        {{ I18n.t("orders.new") }}
      </button>
    </div>
  </div>
  <div v-else class="col-sm-5 col-lg-4 ml-lg-auto mt-2 mt-md-3 mt-lg-0">
      <a :href="Routes.new_user_session_path()" class="btn btn__default">
        {{ I18n.t("orders.new") }}
      </a>
  </div>
</template>

<script>
  /* global Routes */
  import { UPDATE_CURRENT_ARTWORK_INDEX } from '../../../store/mutation-types';

  export default {
    name: 'OrderDetails',
    data() {
      return {
        Routes,
        orderPresent: false,
      };
    },
    props: {
      artwork: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
    },
    computed: {
      canNotOrderForHammer() {
        return this.artwork.auctionsCatalog.auctionType === 'hammer' &&
        this.artwork.auctionsCatalog.state === 'in_progress';
      },
      canNotOrderForLive() {
        return this.artwork.auctionsCatalog.auctionType === 'live' &&
        !this.artwork.auctionExistOrPending;
      },
      currentUserOrder() {
        return this.artwork.currentUserOrder;
      },
    },
    watch: {
      currentUserOrder: {
        immediate: true,
        handler() {
          this.orderPresent = Object.prototype.hasOwnProperty.call(this.artwork, 'currentUserOrder');
        },
      },
    },
    methods: {
      openModal(currentIndex) {
        this.$store.commit(UPDATE_CURRENT_ARTWORK_INDEX, currentIndex);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/row/order_details.vue?be8a569c